/** @format */

import React, { FunctionComponent, useMemo } from 'react';
import PlatformResellerModify, { PlatformResellerSendType } from './PlatformResellerModify';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { history } from '../../core/history';
import { platformResellerConstants } from '../../modules/platformreseller/actions';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import { NotificationHelper } from '../../helpers/NotificationHelper';

// const _ = require('underscore')

export type PlatformUserAddType = {
    match: any;
};

export const PlatformResellerAdd: FunctionComponent<PlatformUserAddType> = ({ match }): React.ReactElement => {
    const dispatch = useDispatch();
    const parentId = useMemo((): string | null => {
        return match?.params?.parentResellerId;
    }, [match]);

    const savePlatformReseller = (outputObject: PlatformResellerSendType): void => {
        if (!parentId) {
            return;
        }
        const itemLoaders = new ItemLoaders(dispatch);

        outputObject.parentResellerId = parseInt(parentId);
        outputObject.active = 1;

        if (outputObject.rpt?.trim().length !== 5) {
            NotificationHelper.notifyError('platform_reseller:notify.rpt_length_error', dispatch);
            return;
        }

        itemLoaders.postWithCallback(
            FormGeneralHelper.getUrl('/platform_resellers', 'platform'),
            platformResellerConstants.PLATFORM_RESELLER_ADD,
            outputObject,
            (data: PlatformResellerInterface): void => {
                // const uri = FormGeneralHelper.getByUri(data['@id']);
                const redirectUri = FormGeneralHelper.getRouteUrl('/platform-reseller-edit/' + data['@id']);
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                history.push(redirectUri);
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    return <PlatformResellerModify parentId={parentId} savePlatformReseller={savePlatformReseller} />;
};

export default PlatformResellerAdd;
